import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-699fde02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "info"
}

import { ref, computed, reactive, onMounted } from "vue";
import CollapsibleItem from "@/layout/collapsible/CollapsibleItem.vue";
import { storeToRefs } from "pinia";
import { patientStore } from "@/store/patient";
import ReportButton from "../Report/ReportButton.vue";
import { Contatti } from "@/../../EshJSLib/models/patient";
import pazienteForm from "@/../../EshJSLib/models/form/pazienteForm.json";
import pazienteFormEmergenza from "@/../../EshJSLib/models/form/pazienteFormEmergenza.json";
import pazienteFormAltriContatti from "@/../../EshJSLib/models/form/pazienteFormAltriContatti.json";
import PazienteBaseEdit from "@/views/schedaPaziente/pazienteBaseEdit.vue";
import PazienteMedicheEdit from "@/views/schedaPaziente/pazienteMedicheEdit.vue";
import PazienteAggiuntiveEdit from "@/views/schedaPaziente/pazienteAggiuntiveEdit.vue";
import emergenzaCreate from "@/views/schedaPaziente/emergenzaCreate.vue";
import moreContactsCreate from "@/views/schedaPaziente/moreContactsCreate.vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import DeleteModal from "@/components/DeleteModal.vue";
import CardComponent from "./CardComponent.vue";
import { getStatiMatrimoniali } from "../../../../EshJSLib/services/EshLOV";
import ModalConfidenzialita from "@/views/schedaPaziente/modal_confidenzialita.vue";

interface ModalStatus {
  base: boolean;
  aggiuntive: boolean;
  mediche: boolean;
  confidenzialita:boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SchedaPaziente',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const statiOptionList = ref([]);
const isShowModal: ModalStatus = reactive({
  base: false,
  aggiuntive: false,
  mediche: false,
  confidenzialita: false,
})

onMounted(async () => {
  store.fetchEmergencyContact();
  store.fetchMoreContacts();
  getStatiMatrimoniali().then(value => {
    statiOptionList.value = value
  })
});

const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const deleteModal = ref<InstanceType<typeof DeleteModal> | null>(null);
const modalAddorEditContact = ref<InstanceType<typeof emergenzaCreate> | null>(null);
const modalAddorEditMoreContacts = ref<InstanceType<typeof moreContactsCreate> | null>(null);
const modalConfidenzialita = ref<InstanceType<typeof ModalConfidenzialita> | null>(null);

function editDetails(editOn) {
  if (patient) {
    isShowModal[editOn] = true;
  }
}

function display(approval) {
  if (approval == "0") {
    return "Non accosento";
  } else if (approval == "1") {
    return "Acconsento";
  } else {
    return approval;
  }
}

function checkSesso(val) {
  switch(val) {
    case 'unknown' :
      return 'Non definito';
    
    case 'male' :
      return 'Maschile';

    case 'female' :
      return 'Femminile';
  }

  return val;
}

let indexgl = ref(null);
const showLoading = ref(false);

async function action(type: string, row: Contatti, index?: number, table?: string) {
  let userInput;

  switch (type) {
    case "pen":
      indexgl.value = row.id_contatto;

      if (row.id_contatto === undefined) {
        row.id_contatto = 0;
      }
      row.id_paziente = patient.value.id_paziente;
      row.author_id = patient.value.id_paziente;

      if (row.id_contatto_tipologia == 10) {
        row.id_contatto_tipologia = 10;
        userInput = await modalAddorEditContact.value?.openModal("Modifica il contatto", true, row);

        if (userInput) {
          showLoading.value = true;
          try {
            await store.savePaziente("contattiemergenza", row.id_contatto);
            showLoading.value = false;
            await alertModal.value?.openModal("Salvato con successo! ", false);
            store.fetchEmergencyContact();
          } catch (res) {
            showLoading.value = false;
            await alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
            store.fetchEmergencyContact();
          }
        }
      } else {
        row.id_contatto_tipologia = 0;
        userInput = await modalAddorEditMoreContacts.value?.openModal("Modifica il contatto", true, row);

        if (userInput) {
          showLoading.value = true;
          try {
            await store.savePaziente("contattialtro", row.id_contatto);
            showLoading.value = false;
            await alertModal.value?.openModal("Salvato con successo! ", false);
            store.fetchMoreContacts();
          } catch (res) {
            showLoading.value = false;
            await alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
            store.fetchMoreContacts();
          }
        }
      }
      break;

    case "lock":
      userInput = await modalConfidenzialita.value?.openModal(null, true, row as unknown as Contatti);
      if (userInput) {
        showLoading.value = true;

        if (row.id_contatto_tipologia == 10) {
          store.savePaziente("contattiemergenza", row.id_contatto).then((x) => {
            showLoading.value = false;
            store.fetchEmergencyContact();
            alertModal.value?.openModal("Salvato con successo! ", false);
          });
        } else {
          store.savePaziente("contattialtro", row.id_contatto).then((x) => {
            showLoading.value = false;
            store.fetchMoreContacts();
            alertModal.value?.openModal("Salvato con successo! ", false);
          });
        }
      }
      break;

    case "trash":
      indexgl.value = row.id_contatto;
      userInput = await deleteModal.value?.openModal(null, true);

      if (userInput) {
        showLoading.value = true;
        if (row.id_contatto_tipologia == 10) {
          row.id_contatto_tipologia = -1;
          await store.savePaziente("contattiemergenza", row.id_contatto).then(() => {
            showLoading.value = false;
            alertModal.value?.openModal("Contatto eliminato con successo! ", false);
            store.fetchEmergencyContact()
          })
          .catch((res) => {
            row.id_contatto_tipologia = 10;
            showLoading.value = false;
            alertModal.value?.openModal("Errore durante l'eliminazione " + res, false);
            store.fetchEmergencyContact();
          });
        } else {
          row.id_contatto_tipologia = -1;
          await store.savePaziente("contattialtro", row.id_contatto).then(() => {
            showLoading.value = false;
            alertModal.value?.openModal("Contatto eliminato con successo! ", false);
            store.fetchMoreContacts()
          })
          .catch((res) => {
            row.id_contatto_tipologia = 0;
            showLoading.value = false;
            alertModal.value?.openModal("Errore durante l'eliminazione " + res, false);
            store.fetchMoreContacts();
          });
        }
      }
      break;

      default:
      break;
  }
}

function getstato(id: string) {
  return statiOptionList.value.filter(stati => stati.id_stato_matrimoniale == id)[0]?.stato_matrimoniale_nome;
}

async function addEmergenza() {
  let row: Contatti = {} as Contatti;
  row.id_contatto = 0;
   console.log('new');
   row.id_paziente = patient.value.id_paziente;
   row.author_id = patient.value.id_paziente;
   row.id_contatto_tipologia = 10;
   const userInput = await modalAddorEditContact.value?.openModal("Aggiungere nuovo contatto", true, row);

   if (userInput) {
     showLoading.value = true;
     patient.value.contattiemergenza = patient.value.contattiemergenza.concat(row);
     store.savePaziente("contattiemergenza", row.id_contatto)
       .then(() => {
         showLoading.value = false;
         alertModal.value?.openModal("Salvato con successo! ", false);
         store.fetchEmergencyContact();
       })
       .catch((res) => {
         showLoading.value = false;
         alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
         store.fetchEmergencyContact();
       });
   }
   indexgl.value = patient.value.contattiemergenza.length;
   patient.value.contattiemergenza = patient.value.contattiemergenza.concat(
     reactive(row as Contatti)
   );
}

async function addAltriContatti() {
  let row: Contatti = {} as Contatti;
  row.id_contatto = 0;
  row.id_paziente = patient.value.id_paziente;
  row.author_id = patient.value.id_paziente;
  row.id_contatto_tipologia = 0;
  const userInput = await modalAddorEditMoreContacts.value?.openModal("Aggiungere nuovo contatto", true, row);

  if (userInput) {
    showLoading.value = true;
    patient.value.contattialtro = patient.value.contattialtro.concat(row);
    store.savePaziente("contattialtro", row.id_contatto)
      .then(() => {
        showLoading.value = false;
        alertModal.value?.openModal("Salvato con successo! ", false);
        store.fetchMoreContacts();
      })
      .catch((res) => {
        showLoading.value = false;
        alertModal.value?.openModal("Siamo spiacenti si è verificato un errore. La preghiamo di riprovare più tardi", false);
        store.fetchMoreContacts();
      });
   }
   indexgl.value = patient.value.contattialtro.length;
   patient.value.contattialtro = patient.value.contattialtro.concat(reactive(row as Contatti));
}

const formattedDate = computed(() => {
  const date = new Date(patient.value.paziente_nascita);
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const year = date.getFullYear().toString();
  return `${day}/${month}/${year}`;
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_unref(patient))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DeleteModal, {
          ref_key: "deleteModal",
          ref: deleteModal
        }, null, 512),
        _createVNode(AlertModal, {
          ref_key: "alertModal",
          ref: alertModal
        }, null, 512),
        (showLoading.value)
          ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(ModalConfidenzialita, {
          ref_key: "modalConfidenzialita",
          ref: modalConfidenzialita
        }, null, 512),
        _createVNode(emergenzaCreate, {
          ref_key: "modalAddorEditContact",
          ref: modalAddorEditContact
        }, null, 512),
        _createVNode(moreContactsCreate, {
          ref_key: "modalAddorEditMoreContacts",
          ref: modalAddorEditMoreContacts
        }, null, 512),
        (isShowModal.base)
          ? (_openBlock(), _createBlock(PazienteBaseEdit, {
              key: 1,
              onCancel: _cache[0] || (_cache[0] = ($event: any) => (isShowModal.base=false))
            }))
          : _createCommentVNode("", true),
        (isShowModal.aggiuntive)
          ? (_openBlock(), _createBlock(PazienteAggiuntiveEdit, {
              key: 2,
              onCancel: _cache[1] || (_cache[1] = ($event: any) => (isShowModal.aggiuntive=false))
            }))
          : _createCommentVNode("", true),
        (isShowModal.mediche)
          ? (_openBlock(), _createBlock(PazienteMedicheEdit, {
              key: 3,
              onCancel: _cache[2] || (_cache[2] = ($event: any) => (isShowModal.mediche=false))
            }))
          : _createCommentVNode("", true),
        _createVNode(CollapsibleItem, {
          id: "anagraficaCollaps",
          data: _unref(pazienteForm)
        }, {
          default: _withCtx(() => [
            (_unref(patient).user != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(CardComponent, {
                    id: "anagraficaCmpt",
                    header: _ctx.$t('Dati anagrafici'),
                    onEditDetails: _cache[3] || (_cache[3] = ($event: any) => (editDetails('base'))),
                    label1: _ctx.$t('Nome:'),
                    "label1-data": _unref(patient).paziente_nome,
                    label2: _ctx.$t('Cognome:'),
                    "label2-data": _unref(patient).paziente_cognome,
                    label3: _ctx.$t('C.F:'),
                    "label3-data":  _unref(patient).paziente_codfiscale == null ? null : _unref(patient).paziente_codfiscale.toUpperCase(),
                    label4: _ctx.$t('Data di nascita:'),
                    "label4-data": formattedDate.value,
                    label5: _ctx.$t('Sesso:'),
                    "label5-data": checkSesso(_unref(patient).paziente_sesso),
                    label6: _ctx.$t('Stato civile:'),
                    "label6-data": getstato(_unref(patient).id_stato_matrimoniale),
                    label7: _ctx.$t('Città di nascita:'),
                    "label7-data": _unref(patient).user.contact_detail?.comune_nascita
                  }, null, 8, ["header", "label1", "label1-data", "label2", "label2-data", "label3", "label3-data", "label4", "label4-data", "label5", "label5-data", "label6", "label6-data", "label7", "label7-data"]),
                  _createVNode(CardComponent, {
                    id: "recapitiCmpt",
                    header: _ctx.$t('Recapiti'),
                    onEditDetails: _cache[4] || (_cache[4] = ($event: any) => (editDetails('aggiuntive'))),
                    label1: _ctx.$t('Città di residenza:'),
                    "label1-data": _unref(patient).user.contact_detail?.comune_residenza,
                    label2: _ctx.$t('Via di residenza:'),
                    "label2-data": _unref(patient).user.contact_detail?.contatto_indirizzo,
                    label3: _ctx.$t('Email:'),
                    "label3-data": _unref(patient).user.email,
                    label4: _ctx.$t('Phone:'),
                    "label4-data": _unref(patient).user.contact_detail?.contatto_telefono
                  }, null, 8, ["header", "label1", "label1-data", "label2", "label2-data", "label3", "label3-data", "label4", "label4-data"]),
                  _createVNode(CardComponent, {
                    id: "infoMedCmpt",
                    header: _ctx.$t('Informazioni mediche'),
                    onEditDetails: _cache[5] || (_cache[5] = ($event: any) => (editDetails('mediche'))),
                    label1: _ctx.$t('Gruppo Sanguigno:'),
                    "label1-data": _unref(patient).paziente_gruppo,
                    label2: _ctx.$t('Donazione organi:'),
                    "label2-data": _ctx.$t(display(_unref(patient).paziente_donatore_organi))
                  }, null, 8, ["header", "label1", "label1-data", "label2", "label2-data"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "emergenzaCollaps",
          data: _unref(pazienteFormEmergenza),
          onRowActions: _cache[6] || (_cache[6] = (n, r, i) => action(n, r, i, 'contattiemergenza')),
          onCreateForm: addEmergenza
        }, null, 8, ["data"]),
        _createVNode(CollapsibleItem, {
          id: "altriContattiCollaps",
          data: _unref(pazienteFormAltriContatti),
          onRowActions: _cache[7] || (_cache[7] = (n, r, i) => action(n, r, i, 'altriContatti')),
          onCreateForm: addAltriContatti
        }, null, 8, ["data"])
      ]))
    : _createCommentVNode("", true)
}
}

})